import { css } from '@emotion/react'
import { HFlow, Icon, Text, Theme, Tooltip, useTheme } from 'bold-ui'
import { AccordionCompositeItem } from 'components/accordion/AccordionCompositeItem'
import { LoadingIndicator } from 'components/loading'
import { useMemo } from 'react'
import { Accordion } from 'react-accessible-accordion'

interface MChatRfAccordionProps {
  children: React.ReactNode
  isPreExpanded?: boolean
  isLoading?: boolean
}

export function MChatRfAccordion(props: Readonly<MChatRfAccordionProps>) {
  const { children, isPreExpanded, isLoading } = props

  const theme = useTheme()
  const styles = useMemo(() => createStyles(theme), [theme])

  const tooltipText =
    'É um instrumento de triagem em dois estágios, baseado no relato dos pais/cuidadores, para avaliar risco de Transtorno do Espectro Autista (TEA).'

  return (
    <Accordion allowZeroExpanded preExpanded={isPreExpanded ? ['mchat'] : []}>
      <AccordionCompositeItem
        header={
          <HFlow alignItems='center'>
            <Text fontWeight='bold' fontSize={1}>
              M-CHAT-R/F™ <span css={styles.innerTitle}>(Checklist Modificado para Autismo em Crianças Pequenas)</span>
            </Text>
            <Tooltip text={tooltipText}>
              <Icon icon='infoCircleFilled' size={1} style={styles.icon} />
            </Tooltip>
          </HFlow>
        }
        body={isLoading ? <LoadingIndicator message='Carregando dados do M-CHAT-R/F™...' /> : children}
        accordionItemStyle={styles.accordionItemStyle}
        accordionButtonContentStyle={styles.accordionButtonContent}
        uuid='mchat'
      />
    </Accordion>
  )
}

const createStyles = (theme: Theme) => ({
  accordionItemStyle: css`
    &[aria-expanded='true'] {
      border-bottom: 1px solid ${theme.pallete.gray.c60};
    }
  `,
  accordionButtonContent: css`
    height: 3.5rem;
  `,
  innerTitle: css`
    font-weight: normal;
  `,
  icon: css`
    margin-left: -0.5rem;
  `,
})
